import {SignUpRoute} from '@/routeRegistry'

export default function Referral() {
  const navigate = useNavigate()

  // Immediately navigate to the Sign Up
  void navigate({
    to: SignUpRoute.fullPath,
  })

  return null
}
